/* RESPONSIBLE TEAM: team-channels */
import EmbercomBaseSerializer from 'embercom/serializers/base/embercom-base-serializer';

export default EmbercomBaseSerializer.extend({
  primaryKey: 'full_name',
});
